import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import onClickOutside from 'react-onclickoutside';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link, NavHashLink as NavLink } from 'react-router-hash-link';
import { StoreButtons } from 'C4';
import { name } from 'settings';
import { spring, StaggeredMotion } from 'react-motion';

import logo from 'assets/images/logo/logo_white.png';

const menuItems = [
  {
    path: '/main',
    text: 'nav.home',
    key: 'home',
    exact: true,
    icon: 'home',
  },
  {
    path: '/main/training',
    text: 'nav.train',
    key: 'training',
    icon: 'graduation-cap',
  },
  {
    path: '/main/retain',
    text: 'nav.retain',
    key: 'retain',
    icon: 'book-reader',
  },
  {
    path: '/main/promote',
    text: 'nav.promote',
    key: 'promote',
    icon: 'book-reader',
  },
  {
    path: '/main/sell',
    text: 'nav.sell',
    key: 'sell',
    icon: 'chart-line',
  },
  {
    path: '/logout',
    text: 'general.logOut',
    key: 'logout',
    icon: 'sign-out-alt',
  },
];

const startingPoints = [
  { pos: -75 },
  { pos: -75 },
  { pos: -75 },
  { pos: -75 },
  { pos: -75 },
  { pos: -75 },
];

class SideMenu extends Component {
  constructor(props) {
    super(props);
    const container = document.getElementById('container');
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentWillMount() {
    container.classList.add('offsetContainer');
  }

  handleClickOutside() {
    this.props.handleClickOutside();
  }

  render() {
    return (
      <div className="sideMenu">
        <div className="sideMenu__Header">
          <div onClick={this.handleClickOutside} className="sideMenu__Header-close">
            <FontAwesomeIcon icon={['fas', 'times']} />
          </div>
          <NavLink onClick={this.handleClickOutside} to="/main" className="sideMenu__Header-logo">
            <img src={`/${logo}`} className="logo" alt={name} />
          </NavLink>
        </div>
        <div className="sideMenu__Nav">
          <StaggeredMotion
            defaultStyles={startingPoints}
            styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => {
              return i === 0
                ? { pos: spring(0, { stiffness: 320, damping: 28 }) }
                : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) };
            })}
          >
            {styles => (
              <ul>
                {menuItems.map((item, index) => {
                  const key = index;
                  return (
                    <li style={{ transform: `translateX(${styles[index].pos}%)` }} key={item.key}>
                      <NavLink
                        key={key}
                        onClick={this.handleClickOutside}
                        exact
                        activeClassName="is-active"
                        to={item.path}
                      >
                        {item.icon && <FontAwesomeIcon icon={['fas', item.icon]} />}
                        {i18n.translate(item.text)}
                        {item.desc && <p className="sideMenu__description">{item.desc}</p>}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            )}
          </StaggeredMotion>
        </div>
        <StoreButtons title />
      </div>
    );
  }
}

export default onClickOutside(SideMenu);

SideMenu.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  handleClickOutside: PropTypes.func,
};

SideMenu.defaultProps = {
  firstName: 'User',
  lastName: 'Name',
  email: 'username@email.com',
  handleClickOutside: () => {
    this.setState({
      menuToggle: false,
    });
  },
};
